/* eslint-disable react/button-has-type */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Camera } from '@one-thd/sui-icons';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import useExternalScript from './useExternalScript';

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  align-items: center;
`;

const Button = styled.button`
  font-weight: bolder;
  padding: 5px 15px;
  border: 2px solid #f96303;
  color: #f96303;
  width: 100%;
  &:hover {
    transition: all 0.5s ease;
    border: 2px solid black;
    background-color: black;
    color: white;
  }
`;

const Wrapper = styled.div`
  width: 100%;
`;

function RoomVO({
  appName, useRoomVOIntegration, roomVOAppScriptId, externalId, roomVOIntegrationUrl, storeNumber, isPcp,
}) {
  useExternalScript(appName, useRoomVOIntegration, roomVOIntegrationUrl, roomVOAppScriptId);

  const ctx = useContext(ExperienceContext);
  const { channel } = ctx;
  const isMobile = channel === 'mobile';

  if (isPcp) return null;

  const roomVOContainer =
    <div className="roomvo-container" data-product-type-str={appName}>
      <Button
        className="roomvo-stimr sui-btn"
        data-sku={externalId}
        style={{ visibility: 'hidden' }}
        data-store-number={storeNumber}
      >
        <Camera style={{ paddingRight: '5px', color: '#f96303' }} />
        See This In My Room
      </Button>
    </div>;

  return (
    <FlexColumn>
      <Wrapper>
        {isMobile ?
          (
            <div className="roomvo-mobile-container">
              {roomVOContainer}
            </div>
          ) :
          roomVOContainer}
      </Wrapper>
    </FlexColumn>
  );
}

RoomVO.propTypes = {
  externalId: PropTypes.number.isRequired,
  roomVOIntegrationUrl: PropTypes.string.isRequired,
  storeNumber: PropTypes.number.isRequired,
  useRoomVOIntegration: PropTypes.bool.isRequired,
  roomVOAppScriptId: PropTypes.string.isRequired,
  appName: PropTypes.string.isRequired,
  isPcp: PropTypes.bool,
};

RoomVO.defaultProps = {
  isPcp: false,
};

export default RoomVO;
